import excel_icon_url from "../../assets/svgIcons/excelIcon.svg"
import zoho_icon_url from "../../assets/zoho-1 1.svg";
export const importTypes = {
    FILE: "FILE",
    ZOHO: "ZOHO",
  }
  
export  const importOptions = [
    { name: 'Excel', value: importTypes.FILE, icon:<img src={excel_icon_url} style={{width:"auto", height:'35px'}} alt="'excel_icon"/> },
    { name: 'Zoho', value: importTypes.ZOHO , icon:<img src={zoho_icon_url} style={{width:"65px", height:'35px'}} alt="'zoho_icon"/>},
  ];
  